import { Skeleton, Box, Grid, Card } from "@mui/material";
const FilterSkeleton = () => {
    const skeletons = Array(4).fill(null); // 4 uniform skeletons + 1 different one

    return (
        <Box display="flex" gap={2}>
            {skeletons.map((_, index) => (
                <Skeleton key={index} variant="rectangular" height={40} width={index === 3 ? 170 : 130} sx={{ borderRadius: 1 }} />
            ))}
            <Skeleton variant="rectangular" height={40} width={100} sx={{ borderRadius: 5 }} />
        </Box>
    );
};

interface DetailSkeletonProps {
    filter?: boolean;
    substance?: boolean;
    graph?: boolean;
}

const DetailSkeleton: React.FC<DetailSkeletonProps> = ({ filter = true, substance = true, graph = true }) => {
    return (
        <>
            {filter && <Grid container sx={{ px: 3, alignItems: "center", marginTop: 4 }}>
                <Grid
                    item
                    md={12}
                    xs={12}
                    sx={{ margin: "10px 0px", }}
                    className="summary-left-block"
                >
                    <Box sx={{ display: "flex", flexWrap: 'wrap' }} className="summary-left-widget">
                        <FilterSkeleton />
                    </Box>
                </Grid>
            </Grid>}
            {graph && <Grid container spacing={2} mt={2} px={3}>
                <Grid item container>
                    <Card sx={{ minWidth: "100%", p: graph ? 0 : 2, border: graph ? "none" : "1px solid #ddd" }}>
                        <Box display="flex" justifyContent="center">
                            <Skeleton variant="rectangular" width="100%" height={350} sx={{ p:3, borderRadius: 2 }} />
                        </Box>
                    </Card>
                </Grid>
            </Grid>}

            {/* Related Substances Skeleton */}
            {substance && <Grid container mt={0} sx={{ p:2}}>
                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>

                    {/* Skeleton for Label (Icon and Text) */}
                    <Grid container spacing={0} mt={1} ml={0} mb={0.8} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box className="alignItms" sx={{ display: 'flex', alignItems: 'center' }}>
                            <Skeleton width={120} height={40} />
                        </Box>
                    </Grid>

                    {/* Placeholder for multiple substances cards (in a row) */}
                    {[...Array(5)].map((_, index) => (
                        <Box key={index} sx={{ mb: 2, width: 'calc(11.33% - 16px)', mr: 1.1 }}>
                            <Skeleton sx={{ borderRadius: 3 }} variant="rectangular" height={120} />
                        </Box>
                    ))}
                </Box>
            </Grid>}

        </>
    )
}

export default DetailSkeleton